import { render, staticRenderFns } from "./DanhGiaDDATDetailForm.vue?vue&type=template&id=0c8170fa&"
import script from "./DanhGiaDDATDetailForm.vue?vue&type=script&lang=js&"
export * from "./DanhGiaDDATDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports